import React from "react";
import { ArrowRight, Building2, FileText } from "lucide-react";
import { ClinicScheduleStatusDto } from "@/src/web-api-client";
import { getClinicDefaultimg } from "../../../utils/defaultImage";

interface ClinicCardProps {
  isMobile: boolean;
  clinic: ClinicScheduleStatusDto;
  onSubmitClick: (clinic: ClinicScheduleStatusDto) => void;
  onContainerClick: (clinic: ClinicScheduleStatusDto) => void;
}

export default function HorizontalCard({
  clinic,
  onSubmitClick,
  onContainerClick,
}: ClinicCardProps) {
  return (
    <div
      className="group h-full cursor-pointer overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm transition-all duration-300 hover:-translate-y-0.5 hover:border-green-200 hover:shadow-xl"
      onClick={() => onContainerClick(clinic)}
    >
      <div className="flex h-full flex-col">
        <div className="flex gap-4 pb-0 p-4 md:p-5 md:pb-0">
          <div className="relative h-20 w-20 md:h-24 md:w-24 flex-shrink-0 overflow-hidden rounded-xl border border-slate-200 bg-slate-50">
            <img
              src={clinic.imageUrl ?? getClinicDefaultimg()}
              alt={clinic.clinicName ?? "Phòng khám"}
              loading="lazy"
              className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
            />
          </div>

          <div className="min-w-0 flex-1">
            {/* <div className="mb-2 flex items-center gap-2">
              <span className="inline-flex items-center gap-1 rounded-full bg-green-50 px-2.5 py-1 text-xs font-medium text-green-700 ring-1 ring-green-100">
                <Building2 className="h-3.5 w-3.5" />
                Chuyên khoa
              </span>
            </div> */}

            <h3 className="line-clamp-2 text-base font-bold leading-snug text-slate-900 md:text-[1.15rem]">
              {clinic.clinicName}
            </h3>

            <div className="mt-3 flex items-start gap-2 text-sm text-slate-600">
              <p className="line-clamp-3 leading-6 text-slate-600">
                {clinic.description?.trim()
                  ? clinic.description
                  : "Khám và tư vấn các vấn đề thuộc chuyên khoa này."}
              </p>
            </div>
          </div>
        </div>

        <div className="flex flex-1 items-end justify-end mb-4 mr-4">
          <button
              className="inline-flex mt-2 items-center gap-2 rounded-full bg-primary px-3 py-1.5 md:px-5 md:py-2 text-sm font-semibold text-white shadow-sm transition-all duration-200 hover:bg-green-700 hover:shadow-md active:scale-[0.98]"
              onClick={(e) => {
                e.stopPropagation();
                onSubmitClick(clinic);
              }}
            >
              Đăng ký
              <ArrowRight className="h-4 w-4" />
            </button>
        </div>
      </div>
    </div>
  );
}